import { FaCaretDown, FaCaretUp } from 'react-icons/fa';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const Chevron = ({ isOpen, className }) => (
  <>
    {!isOpen
            && <FaCaretDown className={clsx('inline-block ml-1 my-1 h-4 float-right', className)} />}
    {isOpen
            && <FaCaretUp className={clsx('inline-block ml-1 my-1 h-4 float-right', className)} />}
  </>
);

Chevron.propTypes = {
  isOpen: PropTypes.bool,
  className: PropTypes.string,
};

Chevron.defaultProps = {
  isOpen: false,
  className: undefined,
};

export default Chevron;
